import { render, staticRenderFns } from "./CardModeloChat.vue?vue&type=template&id=2fe8a228&scoped=true&"
import script from "./CardModeloChat.vue?vue&type=script&lang=js&"
export * from "./CardModeloChat.vue?vue&type=script&lang=js&"
import style0 from "./CardModeloChat.vue?vue&type=style&index=0&id=2fe8a228&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe8a228",
  null
  
)

export default component.exports